import React from 'react';
import PropTypes from 'prop-types';

const WiFiPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M16 26.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5zm3.494-4.699A3.999 3.999 0 0 0 16 20a3.999 3.999 0 0 0-3.474 2.015l-2.274-2.011A6.992 6.992 0 0 1 16 17a6.992 6.992 0 0 1 5.771 3.037l-2.277 2.014zm4.536-4.012A9.985 9.985 0 0 0 16 14a9.985 9.985 0 0 0-8.006 4.007l-2.253-1.992A12.978 12.978 0 0 1 16 11c4.184 0 7.906 1.976 10.284 5.046L24.03 18.04zm6.755-5.973l-2.25 1.99A15.971 15.971 0 0 0 16 8a15.97 15.97 0 0 0-12.51 6.024l-2.25-1.99C4.724 7.743 10.042 5 16 5c5.973 0 11.302 2.756 14.785 7.066z"
    />
  );
};

WiFiPath.propTypes = {
  fill: PropTypes.string,
};

export default WiFiPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/wifi.jsx